// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"33":"663027e4","95":"892d8f6b","121":"21bf7e14","278":"6c5714a0","531":"fd49d352","599":"58a732fe","610":"ea85fd11","635":"a2fe4d0a","692":"56a825eb","760":"0378b50b","787":"8956c12c","805":"3f589ed0","906":"903a479b"}[chunkId] + ".chunk.js";
};